// extracted by mini-css-extract-plugin
export var quillEditor = "_ik-1";
export var variable = "_ik-0";